var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExActionsPopUp',{attrs:{"value":_vm.value,"icon":"org_icon_responsibility","destructive":true,"headline":"Delete Microlearning Video","actionLabel":"Delete","htmlInfo":_vm.info,"applyBorderClass":true},on:{"onAction":function($event){return _vm.$emit('onDelete')},"input":function($event){return _vm.$emit('input', false)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }